import { Clickable, Span } from '@ahmdigital/ui';

import constants from '../../../../ahm-constants';

const MoreOptionsLink = ({ className }: { className?: string }) => (
  <Span className={className}>
    Still confused, or after more options? <Clickable to={constants.URLS.SALES.CONTACT_US}>Contact us</Clickable>
  </Span>
);

export default MoreOptionsLink;
